import { render, staticRenderFns } from "./VerPrestacion.vue?vue&type=template&id=6505d46e&scoped=true"
import script from "./VerPrestacion.vue?vue&type=script&lang=js"
export * from "./VerPrestacion.vue?vue&type=script&lang=js"
import style0 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=0&prod&lang=css&external"
import style1 from "spinkit/spinkit.min.css?vue&type=style&index=1&prod&lang=css&external"
import style2 from "./VerPrestacion.vue?vue&type=style&index=2&id=6505d46e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6505d46e",
  null
  
)

export default component.exports